import React, { useState } from 'react'

import { useTranslations } from '@dfb/gatsby-dfb-theme/src/hooks/useTranslations'

import DfbInput from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_input'
import DfbHeadline from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_headline'
import DfbParagraph from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_paragraph'
import DfbCheckbox from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_checkbox'
import MDefaultform from '../m_defaultForm'
import { checkRequireLabel } from '../../../../../../utils/form/checkRequireLabel'
import { extractFields } from '../../../../../../utils/form/extractFields'
import { emailRegex } from '../../../../../../utils/form/emailRegex'

const MDfbReferee = ({ data }) => {
  const t = useTranslations()
  const formType = data.form_definition[0].identifier
  const fields = extractFields(data.form_definition[0].form_field)
  const [email, setEmail] = useState('')

  return (
    <MDefaultform
      buttonLabel="Bestellung aufgeben"
      postUrl={process.env.FORM_API_URL}
      disableCaptcha={data.form_definition[0].captcha === 0}
      identifier={data.form_recipient[0].identifier}
      DOImail={email}
      formType={formType}
    >
      {({ register, errors }) => (
        <>
          {data.headline && <DfbHeadline headline={data.headline} headline_level="h3" add_class="m-Formblock-headline" />}

          {(fields.firstname || fields.lastname || fields.email) && (
            <div className="m-Formblock-row-third">
              {[fields.firstname, fields.lastname].filter(Boolean).map((formItem, index) => (
                <div className="m-Formblock-row-third-cell" key={index}>
                  <DfbInput
                    {...register(formItem.identifier, {
                      required: formItem.required ? t('form.errorMessage.input') : false,
                    })}
                    error={errors[formItem.identifier]}
                    errorMessage={errors?.[formItem.identifier]?.message}
                    label={checkRequireLabel(formItem)}
                    focused
                  />
                </div>
              ))}
              {fields.email && (
                <div className="m-Formblock-row-third-cell">
                  <DfbInput
                    {...register(fields.email.identifier, {
                      required: fields.email.required ? t('form.errorMessage.input') : false,
                      pattern: {
                        value: emailRegex,
                        message: t('form.errorMessage.emailPattern'),
                      },
                      onChange: (e) => {
                        setEmail(e.target.value)
                      },
                    })}
                    error={errors[fields.email.identifier]}
                    errorMessage={errors?.[fields.email.identifier]?.message}
                    label={checkRequireLabel(fields.email)}
                    focused
                  />
                </div>
              )}
            </div>
          )}

          <div className="m-Formblock-spacer"></div>

          {fields.streetandnumber && (
            <div className="m-Formblock-input">
              <DfbInput
                {...register(fields.streetandnumber.identifier, {
                  required: fields.streetandnumber.required ? t('form.errorMessage.input') : false,
                })}
                error={errors[fields.streetandnumber.identifier]}
                errorMessage={errors?.[fields.streetandnumber.identifier]?.message}
                label={checkRequireLabel(fields.streetandnumber)}
                focused
              />
            </div>
          )}

          <div className="m-Formblock-input-half">
            {[fields.postcode, fields.residence].filter(Boolean).map((formItem, index) => (
              <div className="m-Formblock-input" key={index}>
                <DfbInput
                  {...register(formItem.identifier, {
                    required: formItem.required ? t('form.errorMessage.input') : false,
                    ...(formItem.identifier === 'postcode' && {
                      pattern: {
                        value: /^\d+$/,
                        message: t('form.errorMessage.postcodePattern'),
                      },
                    }),
                  })}
                  error={errors[formItem.identifier]}
                  errorMessage={errors?.[formItem.identifier]?.message}
                  label={checkRequireLabel(formItem)}
                  focused
                />
              </div>
            ))}
          </div>

          <div className="m-Formblock-spacer"></div>

          {fields.abonnement && (
            <DfbCheckbox
              text={t('form.abonnement.referee')}
              {...register(fields.abonnement.identifier, {
                required: fields.abonnement.required === 1,
              })}
              error={errors[fields.abonnement.identifier]}
            />
          )}

          <div className="m-Formblock-checkbox">
            <DfbParagraph text={t('form.privacyText')} />
          </div>
        </>
      )}
    </MDefaultform>
  )
}

export default MDfbReferee
